"use client";

import { Button } from "@/components/ui/button";
import { useTranslations } from "@/hooks/useTranslations";
import { usePathname } from "next/navigation";

export default function UnauthorizedPage() {
  const t = useTranslations("auth");
  const pathname = usePathname();

  return (
    <main className="flex grow items-center justify-center px-4 text-center">
      <div className="space-y-6">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">401 - Unauthorized</h1>
          <p className="text-muted-foreground">Please sign in to continue.</p>
        </div>
        <div>
          <Button 
            border 
            href={`/sign-in?redirect=${pathname}`} 
            theme="black" 
            shadow={true} 
            pressEffect={true}>
              {t?.signIn || "Sign in"}
          </Button>
        </div>
      </div>
    </main>
  );
}
